interface BoldTextListProps {
    text: string;
    keyPrefix: string;
}

export const BoldTextList = ({ text, keyPrefix }: BoldTextListProps) => {
    const parts = text.split(/(\*\*[^*]+\*\*)/g);
    return parts
        .filter(part => part !== '')
        .map((part, index) => <BoldText key={`${keyPrefix}-${index}`} part={part} />);
};

interface BoldTextProps {
    part: string;
}

export const BoldText = ({ part }: BoldTextProps) => {
    if (part.startsWith('**') && part.endsWith('**')) {
        return <span className="font-semibold">{part.slice(2, -2)}</span>;
    }
    // Handle trailing unclosed ** during streaming — render as bold immediately
    const unclosedIndex = part.lastIndexOf('**');
    if (unclosedIndex !== -1 && unclosedIndex === part.length - 2) {
        // The part ends with "**" which is an opening marker with no content yet
        return (
            <span>{part.slice(0, -2)}</span>
        );
    }
    if (unclosedIndex !== -1) {
        const before = part.slice(0, unclosedIndex);
        const boldContent = part.slice(unclosedIndex + 2);
        return (
            <>
                {before && <span>{before}</span>}
                <span className="font-semibold">{boldContent}</span>
            </>
        );
    }
    return <span>{part}</span>;
};
